
import backButtonFullHeight from "./back-button-full-height.vue";
import logo from "~/assets/images/logo.png";
export default {
  components: {
    backButtonFullHeight
  },
  props: {
    isLogoRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      logo
    };
  }
};
